import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesSix() {
  return (
    <Container className="p-3">
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title' >Pancreas & Biliary System Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            {/* <p className='service_des_p'>
              Pancreatic and biliary surgeons treat problems of the digestive system. The digestive system, composed of the bile ducts, gallbladder, liver and pancreas, processes fats and vitamins and removes substances the body doesn't need.
            </p> */}
            <p className='service_des_p' >
              The biliary system consists of the gallbladder, hepatic ducts and the bile. The gallbladder stores and concentrates bile, which is then released into the duodenum during meal times to aid in digestion.
            </p>
            <p className='service_des_p'>
              The pancreas is also considered a part of the biliary system because it releases pancreatic juice into the small intestine via a duct that branches off from one of the hepatic ducts.
            </p>
            <p className='service_des_p'>
              Bile is essential for breaking down fats, while pancreatic juice emulsifies fats. This, in turn, increases fat absorption.
            </p>
            {/* <p> The pancreas is a long, flat gland that lies in the middle of the abdomen, just behind the stomach. It produces enzymes which break down food and drink. It also releases hormones to help regulate blood sugar levels and release insulin-a hormone that helps control sugar levels in the bloodstream. </p> */}
            {/* <p> Pancreatitis is an inflammation of the pancreas. It is usually caused by gallstones or alcoholism. </p> */}
            {/* <p> The pancreas consists of two types: exocrine and endocrine. The exocrine portion secretes digestive enzymes into the small intestine while the endocrine part produces hormones including insulin, glucagon and somatostatin. </p> */}
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_title'> Biliary System Procedures </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_p' >
            <p> The transportation of bile follows this sequence: </p>
            <ul>
              <li> When the liver cells secrete bile, it is collected by a system of ducts that flow from the liver through the right and left hepatic ducts.</li>
              <li> These ducts ultimately drain into the common hepatic duct.</li>
              <li> The common hepatic duct then joins with the cystic duct from the gallbladder to form the common bile duct. This runs from the liver to the duodenum (the first section of the small intestine).</li>
              <li> However, not all bile runs directly into the duodenum. About 50% of the bile produced by the liver is first stored in the gallbladder. This is a pear-shaped organ located directly below the liver. </li>
              <li>Then, when food is eaten, the gallbladder contracts and releases stored bile into the duodenum to help break down the fats.</li>
            </ul>
            {/* <ul>
              <li> Bile ducts, small drainpipes that clear the organs of digestive liquid (bile)</li>
              <li> Gallbladder, small organ that stores bile until the body is ready to digest food</li>
              <li> Liver, organ that produces bile, filters blood and helps the body remove waste</li>
              <li> Pancreas, small gland in the abdomen that helps the body digest food and control blood sugar</li>
            </ul> */}
            <p> All of these surgical procedures can be performed in a minimally invasive fashion, when appropriate, through the use of robotic or laparoscopic surgical techniques.</p>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default ServiceDesSix